<template>
  <a :href="href"
     target="_blank">
    <div class="btn"
         :style="{ backgroundColor: color }">
      <img :src="icon"
           alt="icon" />
      <div>{{ label }}</div>
    </div>
    <div v-html="description"></div>
  </a>
</template>

<script>
export default {
  props: {
    href: String,
    icon: String,
    color: String,
    label: String,
    description: String
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  text-align: center;
  color: #595959;
  letter-spacing: 1.75px;

  .btn {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 9px 0 9px 10px;
    border-radius: 9px;
    margin-bottom: 5px;

    div {
      border-left: 1px solid white;
      padding: 5px;
      margin: 0 5px;
      font-weight: bold;
      color: white;
      font-size: 16px;
      letter-spacing: 1px;
    }
  }
}
</style>
